import React from 'react';
import styled from '@benzinga/themetron';
import { SectionTitle } from '@benzinga/core-ui';

export interface SidebarPostsProps {
  attrs?: any;
  posts: {
    ID: number;
    post_name: string;
    post_title: string;
  }[];
}

export const SidebarPostsBlock: React.FC<SidebarPostsProps> = ({ attrs, posts }) => {
  const layout = attrs?.data?.style ?? 'default';
  return (
    <SidebarPostsWrapper className={layout}>
      <SectionTitle className="card-header">{attrs.data.title}</SectionTitle>
      {posts?.map((post, index) => {
        return (
          <PostWrapper className="list" key={`sidebar-post-${index}`}>
            <a href={`https://www.benzinga.com/money/${post?.post_name}/`}>{post.post_title}</a>
          </PostWrapper>
        );
      })}
    </SidebarPostsWrapper>
  );
};

export const SidebarPostsWrapper = styled.div`
  &.money {
    border: 1px solid #ceddf2;
    border-radius: 4px;
    margin-bottom: 1rem;
    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px 12px;
      background: #e1ebfa;
      h3 {
        font-weight: 600;
        color: #283d59;
        font-size: 16px;
      }
      .icon-wrap {
        cursor: pointer;
      }
    }
    .list {
      padding: 10px 12px;
      margin: 0;
      border-bottom: 1px solid #ceddf2;
      a {
        color: #2d2d2d;
        margin-bottom: 0;
        font-size: 14px;
        line-height: 20px;
      }
      &:last-of-type {
        border-bottom: none;
      }
    }
  }
`;

export const PostWrapper = styled.div`
  margin: 0.5rem auto;
  a {
    color: ${({ theme }) => theme.colorPalette.blue500};
    text-decoration: italic;
  }
`;
